import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./base.api.ts";

export interface CategoryType {
  category_type_id: number;
  company_id: number;
  category_type_name: string;
  category_type_description: string;
  createdAt: string;
  updatedAt: string;
}

export interface Category {
  category_id: number;
  category_type_id: number;
  company_id: number;
  priority_id: number;
  category_name: string;
  category_description: string;
  no_of_total_cases: number;
  average_resolution_time: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface Subcategory {
  subcategory_id: number;
  category_id: number;
  priority_id: number;
  subcategory_name: string;
  subcategory_description: string;
  no_of_total_cases: number;
  average_resolution_time: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CategoryTypesResponse {
  categoryTypes: CategoryType[];
}

export interface CategoriesResponse {
  categories: Category[];
}

export interface SubcategoriesResponse {
  subcategories: Subcategory[];
}

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: customBaseQuery,
  tagTypes: ['Category', 'Subcategory'],
  endpoints: (builder) => ({
    // Get category types by company
    getCategoryTypesByCompany: builder.query<CategoryType[], number>({
      query: (company_id) => ({
        url: `/gw/category-types/company/${company_id}`,
        method: "get",
      }),
      transformResponse: (response: CategoryTypesResponse) => {
        return response.categoryTypes;
      },
      providesTags: ['Category'],
    }),

    // Get categories by category type
    getCategoriesByCategoryType: builder.query<Category[], number>({
      query: (category_type_id) => ({
        url: `/gw/categories/category-type/${category_type_id}`,
        method: "get",
      }),
      transformResponse: (response: CategoriesResponse) => {
        return response.categories;
      },
      providesTags: ['Category'],
    }),

    // Get subcategories by category
    getSubcategoriesByCategory: builder.query<Subcategory[], number>({
      query: (category_id) => ({
        url: `/gw/subcategories/category/${category_id}`,
        method: "get",
      }),
      transformResponse: (response: SubcategoriesResponse) => {
        return response.subcategories;
      },
      providesTags: ['Subcategory'],
    }),
  }),
});

export const { 
  useGetCategoryTypesByCompanyQuery,
  useGetCategoriesByCategoryTypeQuery,
  useGetSubcategoriesByCategoryQuery
} = categoryApi;